export const STATUS_PROGRAM_DRAFT = 'draft';
export const STATUS_PROGRAM_INITIATED = 'initiated';
export const STATUS_PROGRAM_CONFIRMED = 'confirmed';
export const STATUS_PROGRAM_PENDING = 'pending';
export const STATUS_PROGRAM_ACCEPTED = 'accepted';
export const STATUS_PROGRAM_READY = 'ready';
export const STATUS_PROGRAM_ACTIVE = 'active';
export const STATUS_PROGRAM_CURRENT = 'current';
export const STATUS_PROGRAM_INACTIVE = 'inactive';
export const STATUS_PROGRAM_ON_HOLD = 'on_hold';
export const STATUS_PROGRAM_CANCELED = 'canceled';
export const STATUS_PROGRAM_ARCHIVED = 'archived';

export const STATUS_PROGRAM_TEMPLATE = {
  STATUS_PROGRAM_DRAFT,
  STATUS_PROGRAM_READY,
};

export const STATUS_PROGRAM_ASSIGNED = {
  STATUS_PROGRAM_DRAFT,
  STATUS_PROGRAM_INITIATED,
  STATUS_PROGRAM_CONFIRMED,
  STATUS_PROGRAM_PENDING,
  STATUS_PROGRAM_ACCEPTED,
  STATUS_PROGRAM_READY,
  STATUS_PROGRAM_ACTIVE,
  STATUS_PROGRAM_CURRENT,
  STATUS_PROGRAM_INACTIVE,
  STATUS_PROGRAM_ON_HOLD,
  STATUS_PROGRAM_CANCELED,
  STATUS_PROGRAM_ARCHIVED,
};

export const STATUS_PROGRAM_ASSIGNED_SHOW = {
  STATUS_PROGRAM_DRAFT,
  // STATUS_PROGRAM_INITIATED,
  // STATUS_PROGRAM_CONFIRMED,
  // STATUS_PROGRAM_PENDING,
  // STATUS_PROGRAM_ACCEPTED,
  STATUS_PROGRAM_ACTIVE,
  STATUS_PROGRAM_CURRENT,
  STATUS_PROGRAM_INACTIVE,
  STATUS_PROGRAM_ON_HOLD,
  STATUS_PROGRAM_CANCELED,
  // STATUS_PROGRAM_ARCHIVED,
};

export const STATUS_PROGRAM = {
  STATUS_PROGRAM_DRAFT,
  STATUS_PROGRAM_INITIATED,
  STATUS_PROGRAM_CONFIRMED,
  STATUS_PROGRAM_PENDING,
  STATUS_PROGRAM_ACCEPTED,
  STATUS_PROGRAM_READY,
  STATUS_PROGRAM_ACTIVE,
  STATUS_PROGRAM_CURRENT,
  STATUS_PROGRAM_INACTIVE,
  STATUS_PROGRAM_ON_HOLD,
  STATUS_PROGRAM_CANCELED,
  STATUS_PROGRAM_ARCHIVED,
};

export const STATUS_PROGRAM_CAN_CHANGE_START_DATE = {
  STATUS_PROGRAM_DRAFT,
  STATUS_PROGRAM_PENDING,
  STATUS_PROGRAM_ACCEPTED,
  STATUS_PROGRAM_READY,
  STATUS_PROGRAM_ACTIVE,
};

export const STATUS_PROGRAM_CAN_SEND_TO_PARTICIPANT = {
  STATUS_PROGRAM_ACTIVE,
  STATUS_PROGRAM_CURRENT,
};



// WEBPACK FOOTER //
// ./src/state-machine/program/status-program.js